import React from "react";
import "./HeroSection.css";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <p className="hero-tag">
            INNOVATION <span>|</span> TECHNOLOGY <span>|</span> IMPACT
          </p>

          <h1>
            Building <span>Intelligent</span>
            <br />
            Solutions for a
            <br />
            Better Tomorrow
          </h1>

          <p className="hero-description">
            MindstreamX Technologies delivers innovative and scalable IT
            solutions that help businesses grow, adapt, and lead in a digital
            world.
          </p>

          <div className="hero-buttons">
            <button
              className="primary-btn"
              onClick={() => navigate("/services")}
            >
              Explore Our Services <span>→</span>
            </button>

            <button
              className="secondary-btn"
              onClick={() => navigate("/portfolio#featured-projects")}
            >
              View Our Projects <span>→</span>
            </button>
          </div>
        </div>

        <div className="hero-visual">
          <img
            src="/images/G3.png"
            alt="Digital technology globe"
            className="hero-globe"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
